export const VISIBLE_AGENTIC_CODER_MODELS = [
  { id: 'claude-opus-4-6', name: 'Claude Opus 4.6', description: 'Most capable', provider: 'claude', shortName: 'Opus' },
  { id: 'claude-sonnet-4-5', name: 'Claude Sonnet 4.5', description: 'Fast & efficient', provider: 'claude', shortName: 'Sonnet' },
  { id: 'kimi-for-coding', name: 'Kimi K2.5', description: 'Visual agentic coding', provider: 'kimi', shortName: 'Kimi' },
  { id: 'glm-5', name: 'GLM-5', description: 'Z.ai agentic coding', provider: 'glm', shortName: 'GLM' },
] as const;

export type VisibleAgenticCoderModelId = typeof VISIBLE_AGENTIC_CODER_MODELS[number]['id'];
